import React, { useEffect, useState } from "react";
import { getCounsellorRatings } from "../api/api";
import { environment } from "../../environments/environments";
import "../CounsellorAllPages/Rating.css";
import { FaStar } from "react-icons/fa";

const Rating = () => {
  const [ratings, setRatings] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getRatings = async () => {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const _id = userData?.id || userData?._id;

      try {
        const values = { counsellor_id: _id };
        const response = await getCounsellorRatings(values);
        if (response?.success && response?.data) {
          setRatings(response.data);
        }
      } catch (error) {
        console.log("Error fetching ratings:", error);
      } finally {
        setLoading(false);
      }
    };

    getRatings();
  }, []);

  const renderStars = (rating) => {
    return (
      <div className="star-container">
        {[...Array(5)].map((_, index) => (
          <FaStar
            key={index}
            size={20}
            color={index < rating ? environment?.Coral_Red : "#ccc"}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="rating-container">
      {loading ? (
        <div className="centered">
          <div className="loader"></div>
        </div>
      ) : ratings.length > 0 ? (
        ratings.map((item) => (
          <div key={item.id} className="rating-card">
            <div className="user-name">{item.user?.name || "Anonymous"}</div>
            {renderStars(item.rating)}
            <div className="review-text">{item.review}</div>
          </div>
        ))
      ) : (
        <div className="centered">
          <div className="no-rating-text">
            No user has given you a rating yet.
          </div>
        </div>
      )}
    </div>
  );
};

export default Rating;
